import { currentEnv, ErrorCode, ErrorHandler } from './config-core'

export {
  ErrorCode,
  ErrorHandler
}

// 默认导出常用配置
export default {
  env: currentEnv,
  // API 路径配置
  api: {
    USER: {
      USER_INFO: 'common/info',
      VERIFICATION_CODE: 'auth/verification-code',
      GET_USER_INFO: 'api/v1/site/member-info'
    },
    SYSTEM: {
      CONFIG: 'system/config',
    },
    WECHAT: {
      JSSDK_SIGN: 'api/wechat/jssdk',
    },
    SITE: {
      REGISTER: 'api/v1/site/register',
      LOGIN: 'api/v1/site/login',
    },
    ENTERPRISE: {
      COMPANY_INFO: 'api/v1/entser/getcompanyinfo',
      PARK_LIST: 'api/v1/entser/getyuanqulist',
      PARK_DETAIL: 'api/v1/entser/getyuanqudetail',
      PARK_APPLY: 'api/v1/entser/apply',
      APPLY_CONFIG: 'api/v1/entser/applyconfig',
      BUILDING_LIST: 'api/v1/entser/getbuildinglist',
      FLOOR_LIST: 'api/v1/entser/getfloorlist',
      ROOM_LIST: 'api/v1/entser/getroomlist',
      STAFF_LIST: 'api/v1/entser/getstafflist',
      STAFF_ADD: 'api/v1/entser/addstaff',
      STAFF_EDIT: 'api/v1/entser/editstaff',
      STAFF_DELETE: 'api/v1/entser/deletestaff',
      COMPANY_ACCOUNT_LIST: 'api/v1/entser/getcompanyaccountlist',
      COMPANY_ACCOUNT_DELETE: 'api/v1/entser/delcompanyaccount',
      COMPANY_ACCOUNT_ADD: 'api/v1/entser/addcompanyaccount',
      COMPANY_ACCOUNT_SELF_DELETE: 'api/v1/entser/delselfcompanyaccount',
      EDIT_COMPANY_INFO: 'api/v1/entser/editcompanyinfo',
      TENANCY_LIST: 'api/v1/entser/ruzhulist',
      GET_KEJI_SERVICE_LIST: 'api/v1/entser/getfuwukejilist',
      GET_JINRONG_SERVICE_LIST: 'api/v1/entser/getfuwujinronglist',
      GET_SHENGCHAN_SERVICE_LIST: 'api/v1/entser/getfuwushengchanlist',
      ADD_KEJI_SERVICE: 'api/v1/entser/addfuwukejilist',
      ADD_JINRONG_SERVICE: 'api/v1/entser/addfuwujinronglist',
      ADD_SHENGCHAN_SERVICE: 'api/v1/entser/addfuwushengchanlist',
      // 报修相关API
      REPAIR_LIST: 'api/v1/entser/getrepairlist',
      REPAIR_ADD: 'api/v1/entser/baoxiu',
      GET_VALID_PARKS: 'api/v1/entser/getvalidyuanqu',
      REPAIR_LIST_NEW: 'api/v1/entser/baoxiulist',
      // 会议室预约相关API
      MEETING_ROOM_LIST: 'api/v1/entser/getmeetingroomlist',
      MEETING_BOOKING_ADD: 'api/v1/entser/addmeetingbooking',
      MEETING_BOOKING_LIST: 'api/v1/entser/getmeetingbookinglist',
      GET_VALID_ROOM: 'api/v1/entser/getvalidroom',
      ROOM_BOOKING: 'api/v1/entser/yuding',
      ROOM_BOOKING_LIST: 'api/v1/entser/yudinglist',
      // 通知公告相关API
      NOTICE_LIST: 'api/v1/entser/getnoticegglist',
      NOTICE_DETAIL: 'api/v1/entser/getnoticeggdetail',
      // 活动相关API
      ACTIVITY_LIST: 'api/v1/entser/gethuodonglist',
      ACTIVITY_DETAIL: 'api/v1/entser/gethuodongdetail',
      // 培训相关API
      TRAINING_LIST: 'api/v1/entser/getpeixunlist',
      TRAINING_DETAIL: 'api/v1/entser/getpeixundetail',
      TRAINING_APPLY: 'api/v1/entser/baoming',
      // 人才服务相关API
      TALENT_SERVICE_LIST: 'api/v1/entser/getrencaifuwuconfig'
    }
  }
} 